import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { AU, FUENTE } from '../../styles/tokensAU';

const entrada = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
`;

// Fondo blanco (las tarjetas azul suave necesitan contraste para no perderse), columna centrada de 480 px y logo: lo comparten todas las páginas del flujo.
const PaginaSuscripcion = ({ children, sinLogo = false }) => (
  <Box sx={{ minHeight: '100vh', bgcolor: AU.blanco, fontFamily: FUENTE, py: { xs: 2.5, sm: 4 }, px: 2 }}>
    <Box
      component="main"
      sx={{
        maxWidth: 480,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        animation: `${entrada} 180ms ease-out both`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }}
    >
      {!sinLogo && (
        <Box sx={{ display: 'flex', justifyContent: 'center', pb: 0.5 }}>
          <img src="/logo-au-dark.png" alt="AU Coaching Services" width="118" height="44" style={{ height: 44, width: 'auto' }} />
        </Box>
      )}
      {children}
    </Box>
  </Box>
);

export default PaginaSuscripcion;
